import React, { useEffect, useState } from 'react'
import { Route } from 'react-router-dom'
import { motion } from 'framer-motion'

import ROUTES from 'constants/routes'
import introAnimation from 'assets/animations/intro.json'
import Home from 'components/Landing/Home'
import GameOverview from 'components/Landing/GameOverview'
import Header from 'components/Landing/Header'
import Footer from 'components/Landing/Footer'
import About from 'components/Landing/About/About'
import PrivacyPolicy from 'components/Landing/PrivacyPolicy'
import LottiePlayer from 'components/Shared/LottiePlayer'

import 'stylesheets/landing.scss'

const Section = ({ children }) => {
  return (
    <div>
      <Header />
      {children}
      <Footer />
    </div>
  )
}

function Landing() {
  const [showIntro, setShowIntro] = useState(true)
  const [lottieRef, setLottieRef] = useState(null)

  useEffect(() => {
    if (lottieRef) {
      // https://github.com/LottieFiles/lottie-react/issues/10
      lottieRef?.addEventListener('complete', () => {
        setShowIntro(false)
      })
    }
  }, [lottieRef])

  if (showIntro)
    return (
      <motion.div
        className="loading-page"
        animate={{
          backgroundColor: ['#000', '#303030'],
          opacity: [0, 1]
        }}
        transition={{
          duration: 2,
          ease: 'easeInOut',
          repeatDelay: 0
        }}
      >
        <LottiePlayer lottieRef={setLottieRef} animationData={introAnimation} loop={false} />
      </motion.div>
    )

  return (
    <div className="fade-in">
      <Route exact path={ROUTES.LANDING_HOME}>
        <Section>
          <Home />
        </Section>
      </Route>
      <Route path={ROUTES.LANDING_GAME_OVERVIEW}>
        <Section>
          <GameOverview />
        </Section>
      </Route>
      <Route path={ROUTES.LANDING_ABOUT}>
        <Section>
          <About />
        </Section>
      </Route>
      <Route path={ROUTES.LANDING_PRIVACY_POLICY}>
        <Section>
          <PrivacyPolicy />
        </Section>
      </Route>
    </div>
  )
}

export default Landing
